import { Loader } from "lucide-react";
import { useState } from "react";

export type TypeLoadImage = {
    src: string,
    alt?: string,
    className?: string,
    iconSize?: number,
}

export const LoadImage = ({ className = "", src, iconSize = 27, alt = "image" }: TypeLoadImage) => {
    const [ state, setState ] = useState(false);
    const handleLoad = () => {
        setState(true);
    };
    return (
        <>
            { !state &&
                <div className="flex flex-1 items-center">
                    <Loader className={`animate-spin text-slate-400`} size={iconSize} />
                </div>
            }
            <img className={`${className || ""} ${!state ? "hidden" : "block"}`} src={src} alt={alt} onLoad={handleLoad} /> 
        </>
    );
};